export const catalog = {
    "title" : "Catálogos",
    "subcategory" : "Subcategoría",
    "provider" : "Proveedor",
    "noProvider" : "No se encuentran proveedores",
    "noCatalog" : "No se encuentran subcategorías",
    "servicesCatalog" : "Catálogo de servicios",
    "priority": {
        1: "Alta",
        2: "Media",
        3: "Baja",
        4: "Urgente"
    },
    "tags": {
        "name": "Nombre del catálogo",
        "associatedCategories" : "Número de categorías asociadas",
        "state" : "Estado",
        "actions" : "Acciones"
    },
    "form": {
        "createTitle": "Creación de catálogo",
        "updateTitle": "Edición de catálogo",
        "deleteTitle" : "Eliminar categoría",
        "deleteTitleSubService" : "Eliminar subcategoría",
        "deleteCatalog" : "Eliminar catálogo",
        "deleteDescription" : "¿Estás seguro que desea eliminar la categoría?",
        "deleteSubServiceDescription" : "¿Estás seguro que desea eliminar la subcategoría?",
        "deleteCatalogDescription" : "¿Estás seguro que desea eliminar el catálogo?",
        "changePriority" : "Cambiar prioridad",
        "changePriorityDescription" : "¿Estás seguro que deseas cambiar la prioridad de la subcategoría? Se eliminará el proveedor asignado.",
        "crud": {
            "categoryName": "El campo nombre de la categoría es requerido",
            "subCategoryName" : "El campo nombre de la subcategoría es requerido",
            "catalogName" : "El campo nombre del catálogo es requerido"
        },
    },
    "button": {
        "addService" : "Agregar categoría",
        "addSubService" : "Agregar subcategoría",
        "edit" : "Editar",
        "save" : "Aceptar",
        "selectAll" : "Seleccionar todo",
        "deselectAll" : "Deseleccionar todo",
        "assign" : "Asignar"
    },
    "messages": {
        "addCategory" : "Agregar categoría",
        "editCategory" : "Editar categoría",
        "editSubCategory" : "Editar subcategoría",
        "addSubCategory" : "Asignar subcategoría",
        "selectProvider" : "Seleccionar proveedor",
        "assignProviders" : "El proveedor que selecciones estará asignado a todas las subcategorías previamente selecciondas",
        "assignProviderSubCategory" : "El proveedor que selecciones estará asignado a esta subcategoría",
        "hasBeenSavedSuccessfully" : "Se ha guardado exitosamente",
        "yourModificationHasBeenSuccessful" : "Su modificación ha sido exitosa",
        "hasBeenAssignedSucessfully" : "Se ha asignado exitosamente"
    },
    "inputs": {
        "textField": "Requiere campo de texto",
        "category" : "Categoría",
        "enterCategory" : " Ingrese categoría",
        "subCategory" : "Subcategoría",
        "priority" : "Asigne prioridad",
        "provider" : "Asigne proveedor",
        "searchProvider" : "Buscar proveedor",
        "searchProviderOrCatalog" : "Buscar catálogo o proveedor",
        "catalogName" : "Nombre del catálogo",
        "searchCatalog" : "Buscar catálogo"
    },
    "modal": {
        "delete" :{
            "success":{
                "title":"El catálogo se eliminó exitosamente"
            },
            "error":{
                "title":"Hay un error y el catálogo no puede ser eliminado"
            },
        },
        "create" :{
            "success":{
                "title":"El catálogo se creó exitosamente"
            },
            "error":{
                "title":"Hay un error y el catálogo no puede ser creado"
            },
        },
        "update" :{
            "success":{
                "title":"El catálogo se actualizó exitosamente"
            },
            "error":{
                "title":"Hay un error y el catálogo no puede ser actualizado"
            },
        },
        "statusUpdate" :{
            "success":{
                "title":"El estado del catálogo se actualizó"
            },
            "error":{
                "title":"Hay un error y el estado del catálogo no puedó ser actualizado"
            },
        }
    }
}